<template>
  <profile-selector
    :profiles="profiles"
    :assigned="assigned"
    :loading="loading"
    :count="count"
    @assign="assignAssociate"
    @unassign="removeAssigned"
    @on-search="onSearch"
    @reached-bottom="onBottomReached"
  />
</template>

<script>

import Listable from '@/components/mixins/listable';
import _ from 'lodash';
import ProfileSelector from './ProfileSelector';
import { API_ROOT } from '../../config';

export default {

  name: 'ProfileSelectorContainer',
  components: {
    ProfileSelector,
  },
  mixins: [Listable],
  props: {
    source: {
      type: String,
      default: 'profiles',
    },
    customer: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      default: 'loadMore',
    },
    pageSize: {
      type: Number,
      default: 6,
    },
  },
  data() {
    return {
      initial_profiles: [],
    };
  },
  computed: {
    profiles() {
      if (!this.$store.state.profiles.items) {
        return [{
          first_name: '',
          last_name: '',
        }];
      }
      return this.$store.state.profiles.items;
    },
    assigned() {
      if (!this.$store.state.profiles.assignment) {
        return {
          first_name: '',
          last_name: '',
        };
      }
      return this.$store.state.profiles.assignment;
    },
    status() {
      return this.$store.state.profiles.status;
    },
    loading() {
      return this.$store.state.profiles.assignedLoading;
    },
    count() {
      return this.$store.state.profiles.count;
    },
  },
  watch: {
    profiles(newVal) {
      if (this.initial_profiles.length) {
        return;
      }
      this.initial_profiles = newVal;
    },
    customer() {
      this.fetchAssigned();
    },
  },
  methods: {
    // eslint-disable-next-line
    onSearch: _.debounce(function (evt) {
      this.search = evt;
    }, 200),
    assignAssociate(stylist) {
      const assigned_to = `${API_ROOT}/profile/${stylist.pk}/`;
      const payload = {
        pk: this.customer.pk,
        assigned_to,
      };
      this.$store.dispatch('customers/patchCustomerInfo', payload).then(() => {
        this.fetchAssigned();
      });
    },
    removeAssigned() {
      const payload = {
        pk: this.customer.pk,
        assigned_to: null,
      };
      this.$store.dispatch('customers/patchCustomerInfo', payload).then(() => {
        this.fetchAssigned();
      });
    },
    fetchData() {
      if (this.loading) {
        console.debug('already loading');
        return;
      }
      this.requestFailed = false;

      const kwargs = {
        ...this.queryParams,
        page: this.truePage,
        search: this.search,
        page_size: this.pageSize,
      };

      this.$store.dispatch(`${this.source}/addAllOrdered`, kwargs).then((response) => {
        if (response && response.data) {
          this.nextPageExists = response.data.next != null;
        }
      }).catch((response) => {
        if (response.response == null) {
          // Network error
          this.requestFailed = true;
        } else if (response.response.status === 404) {
          // Page doesn't exist
        } else {
          // Server errro
          this.requestFailed = true;
        }
        this.$store.commit(`${this.source}/setIsLoading`, false);
      }).finally(() => {});
    },
    fetchAssigned() {
      this.$store.dispatch('profiles/fetchTeam', this.customer.assigned_to);
    },
    onBottomReached() {
      if (this.nextPageExists) {
        this.truePage += 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
